import React, { useEffect, useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { api_url } from "../../constant/constant";
import { useTranslation } from "react-i18next";
import { showToast } from "../../Components/ShowToast/ToastNotification";

const Users = () => {
  const { t } = useTranslation();

  const [searchVal, setSearchVal] = useState("");
  const [data, setUsers] = useState([]);
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [selectedRows, setSelectedRows] = useState({});

  const toggleRow = (id) => {
    setSelectedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  useEffect(() => {
    if (searchVal !== "") {
      const filteredData = data.filter(
        (item) =>
          item.username
            ?.toLowerCase()
            .includes(searchVal?.toLowerCase() || "") ||
          item.firstname
            ?.toLowerCase()
            .includes(searchVal?.toLowerCase() || "") ||
          item.email
            ?.toLowerCase()
            .includes(searchVal?.toLowerCase() || "") ||
          item.source_name
            ?.toLowerCase()
            .includes(searchVal?.toLowerCase() || "") ||
          item.role_name?.toLowerCase().includes(searchVal?.toLowerCase() || "")
      );
      setUsers(filteredData);
    } else {
      fetchUsers(`?page=${currentPage}`);
    }
  }, [searchVal]);
  const selectedEmails = Object.keys(selectedRows)
    .filter((id) => selectedRows[id])
    .map((id) => {
      const user = data.find((u) => u.id == id);
      return user?.email;
    })
    .filter(Boolean);

  const fetchUsers = async (url) => {
    setLoading(true);

    let page = 1;
    if (url !== "") {
      const temp = url.split("?page=");
      page = parseInt(temp[1]);
    }
    setCurrentPage(page);

    try {
      const token = localStorage.getItem("userToken");

      const response = await fetch(api_url + "/users?page=" + page, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();

      setUsers(result.data?.data || []);
      setLinks(result.data?.links || []);
    } catch (error) {
      console.error(error);
      showToast("Error fetching data", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers("");
  }, []);
  const handleDispatchAll = async () => {
    try {
      setLoading(true);
  
      const token = localStorage.getItem("userToken");
  
      const response = await fetch(
        api_url + "/breach-check/check-all-users",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            include_details: true,
          }),
        }
      );
  
      const result = await response.json();
  
      if (result.status === "success") {
        showToast(result.message?.en || "Dispatched successfully", "success");
      } else {
        showToast("Dispatch failed", "error");
      }
    } catch (error) {
      console.error(error);
      showToast("Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit = async () => {
    try {
      if (selectedEmails.length === 0) return;
  
      setLoading(true);
  
      const token = localStorage.getItem("userToken");
  
      const results = [];
  
      for (let email of selectedEmails) {
        const response = await fetch(
          api_url +"/breach-check/search",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              email: email,
              include_details: true,
            }),
          }
        );
  
        const result = await response.json();
        results.push(result);
      }
  
      console.log("All Results:", results);
  
      showToast("Breach check queued successfully", "success");
  
      setSelectedRows({});
    } catch (error) {
      console.error(error);
      showToast("Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        id: "select",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="checkbox"
              checked={
                data.length > 0 &&
                Object.keys(selectedRows).length === data.length
              }
              onChange={(e) => {
                if (e.target.checked) {
                  const all = {};
                  data.forEach((item) => (all[item.id] = true));
                  setSelectedRows(all);
                } else {
                  setSelectedRows({});
                }
              }}
            />
            {t("SelectAll")}
          </div>
        ),
        cell: ({ row }) => (
          <input
            type="checkbox"
            checked={!!selectedRows[row.original.id]}
            onChange={() => toggleRow(row.original.id)}
          />
        ),
      },

      {
        accessorKey: "username",
        header: () => (
          <div style={{ display: "flex", gap: "8px" }}>
            <img src="/images/fi_user.svg" alt="" />
            {t("UserName")}
          </div>
        ),
      },
      {
        accessorKey: "email",
        header: () => (
          <div style={{ display: "flex", gap: "8px" }}>
            <i className="bi bi-envelope"></i>
            {t("Email")}
          </div>
        ),
      },
    ],
    [data, selectedRows]
  );

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="p-4 mb-4">

      {/* TITLE */}
      <div className="pageTitle mb-4">{t("AllUsers")}</div>

      {/* SEARCH BOX */}
      <div className="primaryBlueBox p-5 mb-4">
  <div className="row align-items-end">
    
    {/* SEARCH INPUT */}
    <div className="col-md-4">
      <label className="form-label">{t("SearchUsers")}</label>
      <div className="input-group">
        <input
          type="text"
          className="form-control"
          placeholder={t("Searchbyname")}
          value={searchVal}
          onChange={(e) => setSearchVal(e.target.value)}
        />
        <button className="btn btn-outline-secondary">
          <i className="bi bi-search"></i>
        </button>
      </div>
    </div>

    {/* DISPATCH BUTTON */}
    <div className="col-md-8 d-flex justify-content-end">
  <button
    className="btn btn-success px-4"
    onClick={handleDispatchAll}
    disabled={loading}
  >
    {loading ? "Dispatching..." : "Dispatch All Active"}
  </button>
</div>

  </div>
</div>

      {/* TABLE */}
      <div className="bg-light px-3 py-3 lessonsTableWrapper resTable overflow-auto">

        <div className="d-md-block">
          <table className="table table-bordered table-hover">
            <thead>
              {table.getHeaderGroups().map((hg) => (
                <tr key={hg.id}>
                  {hg.headers.map((h) => (
                    <th key={h.id}>
                      {flexRender(h.column.columnDef.header, h.getContext())}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>

      {/* SUBMIT BUTTON */}
      <div className="mt-3 d-flex justify-content-end">
        <button
          className="btn btn-primary"
          disabled={selectedEmails.length === 0 || loading}
          onClick={handleSubmit}
        >
          {loading
            ? "Submitting..."
            : `Submit (${selectedEmails.length})`}
        </button>
      </div>

      {/* PAGINATION */}
      <div className="navigationWrapper mt-3">
        <ul>
          {links.map((link, index) => (
            <li
              key={index}
              className={`${link.active ? " active " : ""} ${
                link.url === null ? " disabled " : ""
              }`}
              onClick={
                link.url !== null ? () => fetchUsers(link.url) : undefined
              }
            >
              <div dangerouslySetInnerHTML={{ __html: link.label }} />
            </li>
          ))}
        </ul>
      </div>

    </div>
  );
};

export default Users;